<script>
import router from "@/router";
import axios from "axios";

export default {
  data() {
    return {
      email: null,
      errors: [],
      flash: null,
    }
  },
  methods: {
    checkEmailIsValid() {
      this.errors = []

      if (!this.email) {
        this.errors.push('Email requis.');
      } else {
        const data = {email: this.email}
        this.flash = {
          message: 'Si un compte existe, un email vous sera envoyé avec les instructions à la modification de votre mot de passe.',
          type: 'success'
        }

        axios.post(process.env.VUE_APP_API_URL + '/reset-password', data).then(response => {
          this.flash = {
            message: response.data,
            type: 'success'
          }
          this.email = null
        }).catch(e => {
          this.flash = {
            message:e.response.data,
            type: 'danger'
          }
        })
      }
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="position-fixed top-0 translate-middle-x p-3" style="right: 0;">
      <div :class="'toast bg-'+ flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer"
                  @click="clearFlash"></button>
        </div>
      </div>
    </div>
    <p class="alert alert-danger" v-if="errors.length">
      <b>Merci de corriger les erreurs suivantes:</b>
      <ul>
        <li v-for="error in errors">{{ error }}</li>
      </ul>
    </p>
    <form action="#" @submit.prevent="checkEmailIsValid()" method="post">
      <div class="mb-3">
        <label for="email" class="form-label">Email*</label>
        <input type="email" class="form-control" id="email" placeholder="John@doe.com" v-model="email" required
               pattern="[\w\-\.]+@([\w\-]+\.)+[\w\-]{2,4}">
        <div class="invalid-feedback">
          Merci de saisir un email valide.
        </div>
      </div>
      <button type="submit" class="btn btn-primary">Envoyer l'email</button>
    </form>
  </div>
</template>

<style scoped>

</style>